import { BaseError } from '../../_base/lang/BaseError';

export class CannotCancelError extends BaseError {}
